import {RootState, Widget, WidgetState} from '@/types';
import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import WidgetService from '@/services/widget.service';

type WidgetGetter = GetterTree<WidgetState, RootState>;

export const initialState = (): WidgetState => {
  return {
    initialState,
    widgetFilters: [],
    widgets: [],
  };
};

export const getters: WidgetGetter = {
  widgetFilters: (state) => state.widgetFilters,
};

export const mutations: MutationTree<WidgetState> = {
  addWidgetFilters(state, newValue) {
    const filters: string[] = [];
    filters.push(newValue);
    Object.assign(state.widgetFilters, filters);
  },
  removeAllWidgetFilters(state) {
    Object.assign(state, initialState());
  },
  removeWidgetFilter(state, filterToRemove) {
    state.widgetFilters = state.widgetFilters.filter((wf) => wf === filterToRemove);
  },
  getWidgets(state, newWidgets) {
    state.widgets = newWidgets;
  },
  updateWidget(state, updatedWidget: Widget) {
    state.widgets[state.widgets.findIndex((w: Widget) => w.id === updatedWidget.id)] = updatedWidget;
  },
  removeWidget(state, widgetId: string) {
    state.widgets = state.widgets.filter((w) => w.id !== widgetId);
  },
};

export const actions: ActionTree<WidgetState, RootState> = {
  async getWidgetsAsync(context: any) {
    const widgets = await WidgetService.getWidgets();
    context.commit('getWidgets', widgets);
    return widgets;
  },
  async updateWidgetAsync(context: any, widgetToUpdate: { id: string, payload: object }) {
    const updatedWidget = await WidgetService.updateWidget(widgetToUpdate.id, widgetToUpdate.payload);
    context.commit('updateWidget', updatedWidget);
    return updatedWidget;
  },
  async removeWidgetAsync(context: any, widgetId: string) {
    const response = await WidgetService.removeWidget(widgetId);
    context.commit('removeWidget', widgetId);
    return response;
  },
};

export const widget: Module<WidgetState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
